import { Component, input, Input } from '@angular/core'

@Component({
	selector: 'option-icon',
	template: `
		<svg
			width="18"
			height="18"
			viewBox="0 0 24 24"
			stroke-width="2"
			stroke="currentColor"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			@if (icon() === 'validations') {
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M3.5 5.5l1.5 1.5l2.5 -2.5" />
				<path d="M3.5 11.5l1.5 1.5l2.5 -2.5" />
				<path d="M3.5 17.5l1.5 1.5l2.5 -2.5" />
				<path d="M11 6l9 0" />
				<path d="M11 12l9 0" />
				<path d="M11 18l9 0" />
			}
			@if (icon() === 'request-car') {
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M5 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
				<path d="M15 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
				<path d="M5 20h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" />
				<path d="M3 6l9 -4l9 4" />
			}
			@if (icon() === 'overnight-report') {
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path
					d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
				/>
				<path
					d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
				/>
				<path d="M9 12h6" />
				<path d="M9 16h6" />
			}
			@if (icon() === 'valet-service-monitoring') {
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path
					d="M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10z"
				/>
				<path d="M7 20h10" />
				<path d="M9 16v4" />
				<path d="M15 16v4" />
			}
			@if (icon() === 'chat') {
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M8 9h8" />
				<path d="M8 13h6" />
				<path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
			}
		</svg>
	`,
	styleUrl: './option-icon.component.scss',
	standalone: true,
})
export class OptionIconComponent {
	// @Input() icon: string = ''
	readonly icon = input.required<string>()
}
